<template>
  <div class="footer">
      <div class="wrapper">
        <p class="margin-top-10"> ©广州百景信息科技服务有限公司 2013-2023 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022030857号</a></p>
        <p>技术支持与报障：020-32643353</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'commonFooter'
}
</script>

<style lang="postcss" scoped>
.footer {
  overflow: hidden;
  font-size: 13px;
  height: 80px;
  line-height: 30px;
  background: #071F43;
  color: #fff;
  text-align: center;
}

.margin-top-10 {
  margin-top: 10px;
}
.footer a {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue